import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../components/Layout/Header";
import Sidebar from "../components/Layout/Sidebar";
import Loader from "../components/Layout/Loader";
import AiMemberSocialProfile from "../components/Profile/AiMemberSocialProfile";
import { server } from "../server";
import "../stylesheets/AiMemberProfile.css";

const AiMemberProfilePage = () => {
  const { handle } = useParams();
  const currentUser = useSelector((state) => state.user.user);
  const [aiMember, setAiMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProfile = async () => {
      const { data } = await axios.get(`${server}/ai-member/profile/${handle}`);
      let profile = data.aiMember;

      if (currentUser?._id) {
        try {
          const mineResponse = await axios.get(`${server}/ai-member/mine`, { withCredentials: true });
          const ownedProfile = (mineResponse.data.aiMembers || []).find((item) => item._id === profile._id);
          if (ownedProfile) profile = { ...profile, ...ownedProfile, isOwner: true };
        } catch (error) {
          if (error.response?.status !== 401 && error.response?.status !== 403) throw error;
        }
      }

      setAiMember(profile);
    };

    loadProfile()
      .catch(() => setAiMember(null))
      .finally(() => setLoading(false));
  }, [currentUser?._id, handle]);

  if (loading) return <Loader />;
  if (!aiMember) return <div>AI Member profile not available.</div>;

  return (
    <div className="profile-page ai-member-profile-page">
      <Header />
      <Sidebar />
      <AiMemberSocialProfile profile={aiMember} onProfileChange={setAiMember} />
    </div>
  );
};

export default AiMemberProfilePage;